import type { Swiper as SwiperType } from 'swiper';

const ZOOM_TARGET_SELECTOR = 'picture, img, svg, canvas, .swiper-zoom-target';

export const keepOriginalSizeOnZoomOut = (swiper: SwiperType) => {
	if (!swiper.zoom) {
		return;
	}
	swiper.wrapperEl.addEventListener(
		'pointermove',
		(event: PointerEvent) => {
			if (swiper.zoom.scale >= 1) {
				return;
			}
			const slideEl: Element | undefined =
				(event.target as Element | null)?.closest('.swiper-slide') ??
				swiper.slides[swiper.activeIndex];
			const wrapEl = slideEl?.querySelector<HTMLElement>('.swiper-zoom-container');
			const imageEl = wrapEl?.querySelector<HTMLElement>(ZOOM_TARGET_SELECTOR);
			if (!wrapEl || !imageEl) {
				return;
			}
			wrapEl.style.transform = 'translate3d(0,0,0)';
			imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
		},
		{ capture: true, passive: true }
	);
};
